import React, { useEffect } from 'react';
import { TermsAndConditionsContent } from './termsAndConditionsContent';
import FormattedContent from '../../components/FormattedContent';
import { styled } from '@mui/material';
import Navbar from '../../components/Navbar';
import theme from '../../styles';

const TermsAndConditions = () => {
  useEffect(() => {
    document.title = 'Terms and Conditions - Digital Porters';
  }, []);

  return (
    <MainContainer>
      <Navbar
        position='sticky'
        customtextcolor={theme.color.textPrimary}
        searchBarBackgroundColor={theme.color.beige}
      />
      <PageBackground>
        <LegalContainer>
          <h2>{TermsAndConditionsContent.Title}</h2>
          <FormattedContent content={TermsAndConditionsContent.Content} />
        </LegalContainer>
      </PageBackground>
    </MainContainer>
  );
};

const MainContainer = styled('div')(() => ({}));
const PageBackground = styled('div')(() => ({
  backgroundColor: theme.color.cream,
  minHeight: '100vh',
  paddingTop: 20,
  paddingBottom: 60,
}));
const LegalContainer = styled('div')(() => ({
  maxWidth: 900,
  margin: '0 auto',
  padding: '40px 30px',
  fontFamily: theme.fontFamily.tertiary,
  color: theme.color.textPrimary,
  lineHeight: 1.7,
  fontSize: 16,
  '& h1, & h2, & h3': {
    color: theme.color.primary,
    fontFamily: theme.fontFamily.secondary,
  },
  '& a': {
    color: theme.color.brick,
  },
}));

export default TermsAndConditions;
